<template>
  <div>
    <b-row>
      <b-col>
        <b-tabs
          v-if="displayActivity || displaySettings"
          content-class="scollable-container"
        >
          <b-tab active>
            <template #title>
              <b-spinner
                  v-if="loadingDisplay"
                  type="grow" small
              />
              <h4>Display</h4>
            </template>
            <p style="margin-top: 0px">
                <base-display
                    :resource="resource"
                />
                <slot name="display" />
            </p>
          </b-tab>
          <b-tab v-if="displayActivity">
            <template #title>
              <h4>Activity</h4>
            </template>
            <p class="p-3" style="margin-top: 25px">
              <b-container>
                <base-activity :resource="resource" />
                <slot name="activity"></slot>
              </b-container>
            </p>
          </b-tab>
          <b-tab v-if="displaySettings">
            <template #title>
              <h4>Settings</h4>
            </template>
            <div class="p-3" style="margin-top: 40px">
              <b-container>
                Set-Up and Customize
                <base-settings :resource="resource" :settings="settings" />
                <slot name="settings" />
                <b-button
                  variant="primary btn-round-fill"
                  @click.prevent="handleUpdateSettings"
                >
                  Save Settings
                </b-button>
              </b-container>
            </div>
          </b-tab>
        </b-tabs>
        <div v-else>
          <slot name="display" />
        </div>
      </b-col>
    </b-row>
    <!------ WELCOME|INTRO}ABOUT LAYER ---->
    <about-intro
        :id="aboutIntroId"
        :position="aboutIntroPos"
        :resource="resource"
        :settings="settings"
        @update-settings="handleUpdateSettings"
        @app-log="appLog"
    />
  </div>
</template>

<script>
import AboutIntro from "@/components/modals/aboutIntro";
import BaseDisplay from "./sections/baseDisplay";
import BaseActivity from "./sections/baseActivity";
import BaseSettings from "./sections/baseSettings";
export default {
  name: "BaseResourceModal",
  components: {
    AboutIntro,
    BaseDisplay,
    BaseActivity,
    BaseSettings,
  },
  props: {
    loadingDisplay: {
      type: Boolean,
      default: false
    },
    isManagementMode: {
      type: Boolean,
      default: false
    },
    resource: {
      type: Object,
      default: () => {}
    },
    settings: {
      type: Object,
      default: () => {}
    },
    userData: {
      type: Object,
      default: () => {}
    },
    displayActivity: {
      type: Boolean,
      default: true
    },
    displaySettings: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    //Created and Called by Each App
    //Each app can determine if they even want an about Into
    if (!this.settings || !this.settings.hasSeenAboutIntro ){
      this.handleOpenAboutIntroClick();
    }
  },
  methods: {
    appLog(){
      //Moving logging to the state and possibly using logEvents/Firebase
    },
    handleOpenAboutIntroClick() {
      this.$bvModal.show(this.aboutIntroId);
    },
    handleUpdateSettings() {
      //can be a mixin
      this.$emit("update-settings"); //Resource Base
    }
  },
  data() {
    return {
      aboutIntroId: "about-intro",
      aboutIntroPos: 1,
    };
  },
};
</script>

<style lang="scss" scoped></style>
